import { Flags, Select } from "components/shared/form";
import { shippingDocumentProviderTypes } from "helpers/enums";
import policy from "policies";
import React from "react";

const providerTypeToMask = (providerType) => {
    if (typeof providerType === "number") {
        return providerType;
    }

    if (typeof providerType !== "string") {
        return 0;
    }

    return providerType.split(",").reduce((mask, provider) => {
        const option = shippingDocumentProviderTypes.find((item) => item.value === provider.trim());
        return option ? mask | option.intValue : mask;
    }, 0);
};

const maskToProviderType = (mask) => {
    const selectedProviders = shippingDocumentProviderTypes
        .filter((item) => item.intValue !== 0 && (mask & item.intValue) === item.intValue)
        .map((item) => item.value);

    return selectedProviders.length ? selectedProviders.join(", ") : "ProviderEmulator";
};

export default function EBillsForm(props) {
    const { data, onChange, config, roles, organizationId } = props;
    const disabled = !policy("user", { user: { roles } }).isAdminWithWriteAccess();

    return (
        <>
            <Select
                {...config.userIds}
                url={(params) => config.userIds.url({ ...params, organizationId })}
                value={data.userIds}
                onChange={onChange}
                disabled={disabled}
            />
            <Flags
                {...config.providerType}
                flags={shippingDocumentProviderTypes}
                value={providerTypeToMask(data.providerType)}
                onChange={({ name, value }) => onChange({ name, value: maskToProviderType(value) })}
                disabled={disabled}
            />
        </>
    );
}
